/**
 * State used in rendering Text
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
